var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveFreeze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2181_12898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2181_12898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25006 16.5V13.3875L5.81256 15.7875L4.76256 14.7375L8.25006 11.25V9.75H6.75006L3.26256 13.2375L2.21256 12.1875L4.61256 9.75H1.50006V8.25H4.61256L2.21256 5.8125L3.26256 4.7625L6.75006 8.25H8.25006V6.75L4.76256 3.2625L5.81256 2.2125L8.25006 4.6125V1.5H9.75006V4.6125L12.1876 2.2125L13.2376 3.2625L9.75006 6.75V8.25H11.2501L14.7376 4.7625L15.7876 5.8125L13.3876 8.25H16.5001V9.75H13.3876L15.7876 12.1875L14.7376 13.2375L11.2501 9.75H9.75006V11.25L13.2376 14.7375L12.1876 15.7875L9.75006 13.3875V16.5H8.25006Z",
    fill: "#aaa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveFreeze);
export default __webpack_public_path__ + "static/media/inactive_freeze.23ba5da1b71f7f32294e57bf2d19ada6.svg";
export { ForwardRef as ReactComponent };